module.exports = __webpack_public_path__ + "img/모험심.db6932df.svg";